import { useQuery } from '@tanstack/react-query'

import { UnitDetails } from '@/models/features'

import { authAPI } from '../new-api'

export interface GetUnitRequest {
  unitId: string
}

export type GetUnitResponse = UnitDetails

export const getUnit = async ({ unitId }: GetUnitRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<GetUnitResponse>(`/units/${unitId}`, { signal })
  return response.data
}

export const GET_UNIT_BASE_QUERY_KEY = 'useGetUnit'

export const getUnitQueryKey = (data: GetUnitRequest) => [GET_UNIT_BASE_QUERY_KEY, data] as const

export const useGetUnit = (data: GetUnitRequest) => {
  return useQuery({
    enabled: !!data.unitId,
    queryFn: ({ signal }) => getUnit(data, signal),
    queryKey: getUnitQueryKey(data),
  })
}
